/**
 * Google's encoded polyline → LatLngs the map can draw. Routes come from the
 * backend (`POST /trips/:id/directions/route`) already computed; decoding is the
 * only piece that has to happen here, because it needs the Maps JS geometry lib.
 */
export function decodeEncodedPolyline(encoded: string): google.maps.LatLng[] {
  return window.google.maps.geometry.encoding.decodePath(encoded);
}

export interface LatLngPoint { lat: number; lng: number }

/**
 * The same decoding without the Maps SDK. The story sticker draws the trip's
 * route on a plain canvas from anywhere in the app, and loading the Maps JS
 * bundle just to decode a string would break the rule that the SDK only comes
 * down when a real map is rendered.
 */
export function decodePolylinePoints(encoded: string): LatLngPoint[] {
  const points: LatLngPoint[] = [];
  let index = 0;
  let lat = 0;
  let lng = 0;

  while (index < encoded.length) {
    for (const axis of ['lat', 'lng'] as const) {
      let result = 0;
      let shift = 0;
      let byte: number;
      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20 && index < encoded.length);

      const delta = (result & 1) ? ~(result >> 1) : (result >> 1);
      if (axis === 'lat') lat += delta;
      else lng += delta;
    }
    points.push({ lat: lat / 1e5, lng: lng / 1e5 });
  }

  return points;
}
